// 查询余额明细
const ICBankRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `bankTransfer/ICBank/index${i + 1}`,
  name: `bankTransfer/ICBank/Index${i + 1}`,
  component: () => import(`@/views/shopping/bankTransfer/ICBank/index${i + 1}.vue`)
}))
const HSBankRoutes = Array.from({ length:8 }, (_, i) => ({
  path: `bankTransfer/HSBank/index${i + 1}`,
  name: `bankTransfer/HSBank/Index${i + 1}`,
  component: () => import(`@/views/shopping/bankTransfer/HSBank/index${i + 1}.vue`)
}))

import bankTransferIndex from '@/views/shopping/bankTransfer/index'



export default {
  path: '/shopping',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'bankTransfer/index',
        name: 'bankTransferIndex',
        component: bankTransferIndex
      },
    // 查询余额明细，开始
    ...ICBankRoutes,
    ...HSBankRoutes,

  ],
};
